<template>
  <div class="home-page">
    <!-- 把轮播图和导航放在首页组件里 -->
    <AppCarousel :carouselImages="homeCarouselImages"/>
   
<div class="container">
      <div 
        v-for="(item, index) in filteredList" 
        :key="index" 
        class="title-item" 
       
      >
        {{ item.title }}
      </div>
    </div>


  </div>
  
    
 
  
  
</template>

<script setup>

import { ref } from 'vue';//导入响应式数据
//给数组填充数据
const filteredList = ref([
{title:'脑力开发报名热线',},
{title:'176 3035 6892'}
])
import AppCarousel from '../components/AppCarousel.vue'
// Home页面的轮播图数据
const homeCarouselImages = [
{
    videoPath: '/to-singlevideo',
    url: './pic/carouselPic/2brain.jpg',
    alt: '16:9轮播图1',
    title: '人和人的智商一样吗？智商高的人和普通人的大脑区别在哪里？',
    videosrc: 'https://wk.bqpd.top/b09feb4avodcq1379112376/4712bdf85145403701530952382/pZK2vSOKDUcA.mp4'
  },
{
    videoPath: '/to-singlevideo',
    url: './pic/carouselPic/zn你觉得天赋和勤奋哪个才是决定因素.png',
    alt: '16:9轮播图1',
    title: '你觉得天赋和勤奋哪个才是决定因素？ 大部分人都会认为天赋更重要，那天赋从科学的角度应该如何解释呢？',
    videosrc: 'https://wk.bqpd.top/b09feb4avodcq1379112376/6e6256d65145403701527615243/ZSvAHnNghYcA.mp4'
  },
  {
    videoPath: '/to-singlevideo',
    url: './pic/carouselPic/zn天才们的大脑和普通人的大脑一样吗.png',
    alt: '16:9轮播图1',
    title: '天才们的大脑和普通人的大脑一样吗',
    videosrc: 'https://wk.bqpd.top/b09feb4avodcq1379112376/016977f95145403701529325480/jPDiNn4HY9UA.mp4'
  },
  {
    videoPath: '/to-singlevideo',
    url: './pic/carouselPic/zn什么是照相记忆.png',
    alt: '16:9轮播图1',
    title: '什么是照相记忆，撒贝宁说他的照相记忆天赋助他考上北京大学',
    videosrc: 'https://wk.bqpd.top/b09feb4avodcq1379112376/3b2114105145403701530413139/6DbJVbsB3iMA.mp4'
  },
  {
    videoPath: '/to-singlevideo',
    url: './pic/carouselPic/zn人类的终极阅读速读能有多快.png',
    alt: '16:9轮播图1',
    title: '人类的终极阅读速读能有多快',
    videosrc: 'https://wk.bqpd.top/b09feb4avodcq1379112376/b69e99b35145403701528402722/vyMOd7K3IXIA.mp4'
  },
  
  {
    videoPath: '/to-singlevideo',
    url: './pic/carouselPic/zn你相信这个世界上有天才吗.png',
    alt: '16:9轮播图1',
    title: '你相信这个世界上有天才吗',
    videosrc: 'https://wk.bqpd.top/b09feb4avodcq1379112376/0d35c59d5145403701529842219/FaKYXLfnsFQA.mp4'
  },
  

  { videoPath: '/to-singlevideo',
    url: './pic/carouselPic/报名热线.png', 
    alt: '16:9轮播图1',
     title:'',
     videosrc:'',
     },
  
  
]





</script>
<style scoped>
.container {
  padding: 20rpx;
}

.title-item {
  width: 100%;           /* 宽度充满父容器 */
    box-sizing: border-box; /* 防止padding撑大宽度 */
    padding: 15px;         /* 原30rpx转换为15px（rpx通常1rpx≈0.5px） */
    margin-bottom: 10px;   /* 原20rpx转换为10px */
    background-color: #f5f5f5;
    border-radius: 4px;    /* 原8rpx转换为4px */
    font-size: 16px;       /* 原32rpx转换为16px */
    color: #333;
    border: none;          /* 移除默认边框（如果用于按钮） */
    text-align: left;      /* 文字左对齐 */
    cursor: pointer;       /* 鼠标悬停显示手型 */
    transition: background-color 0.2s ease; /* 平滑过渡效果 */
}

.title-item:active {
  background-color: #e5e5e5; /* 点击反馈效果 */
}


/* 电脑端专属：控制轮播图大小（屏幕≥1024px时生效） */
@media (min-width: 1024px) {
  /* 限制中间显示区宽度为手机竖屏常见宽度（如375px，可修改） */
  .container {
    max-width: 500px !important; /* 中间显示区宽度（手机常见宽度） */
    margin: 20px auto !important; /* 左右自动留白，居中显示 */
  }
}
</style>